export const trackEventConfig = {
  category: 'Users',
  action: 'Reality checks',
} as const;

export const MINUTES_IN_MS = 60 * 1000;
export const HOUR_IN_MS = 60 * MINUTES_IN_MS;
